module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@3x-583842eef89e42ff0e8024a7ca7acce6.png";